(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-product"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('purrstep-purchase'))customElements.define('purrstep-purchase',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;const variants=JSON.parse(this.querySelector('[data-variants]').textContent),labels=JSON.parse(this.querySelector('[data-labels]').textContent),form=this.querySelector('form'),btn=this.querySelector('[data-add]'),error=this.querySelector('[data-error]'),pairs=[...this.querySelectorAll('[data-pair]')];const initial=variants.find(v=>String(v.id)===new URLSearchParams(location.search).get('variant')&&!v.option2.includes('unconfirmed'));if(initial){pairs[0].querySelector('[data-color]').value=initial.option1;pairs[0].querySelector('[data-size]').value=initial.option2;}const cash=n=>new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:this.dataset.currency||'USD'}).format(n/100);const qty=()=>Number(this.querySelector('[name=bundle]:checked').value);const selected=()=>pairs.slice(0,qty()).map(p=>variants.find(v=>v.option1===p.querySelector('[data-color]').value&&v.option2===p.querySelector('[data-size]').value));const update=()=>{const q=qty();pairs.forEach((p,i)=>{p.hidden=i>=q;p.disabled=i>=q});const vs=selected();const valid=vs.every(v=>v&&v.available);const total=vs.reduce((s,v)=>s+(v?.price||0),0)-q*(q===3?Number(this.dataset.trioSaving):q===2?Number(this.dataset.duoSaving):0);btn.disabled=!valid;this.querySelector('[data-add-label]').textContent=valid?labels.add+' · '+cash(total):labels.unavailable;};form.addEventListener('change',update);this.querySelectorAll('[data-image]').forEach(b=>b.addEventListener('click',()=>{const img=this.querySelector('.ps-hero-image');img.src=b.dataset.image;img.removeAttribute('srcset');img.alt=b.dataset.alt;this.querySelectorAll('[data-image]').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));}));this.querySelector('.ps-selector-heading a').addEventListener('click',()=>this.querySelector('.ps-size-guide').open=true);form.addEventListener('submit',async e=>{e.preventDefault();if(this.busy||btn.disabled)return;this.busy=true;btn.disabled=true;error.hidden=true;this.querySelector('[data-add-label]').textContent=labels.adding;const grouped={};selected().forEach(v=>grouped[v.id]=(grouped[v.id]||0)+1);try{const response=await fetch(this.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:Object.entries(grouped).map(([id,quantity])=>({id:Number(id),quantity}))})});const data=await response.json();if(!response.ok)throw new Error(data.description||labels.error);window.location.assign(this.dataset.cartUrl);}catch(e){error.textContent=e.message||labels.error;error.hidden=false;this.busy=false;update();}});update();}
});

  } catch(e) { console.error(e); }
})();
})();
